import React, { useState } from 'react';
import { PageHeader, Card, FormGroup, Input, Select, Button, Badge } from '../../components/common/UIComponents';
import { ChargesController } from '../../controllers';

const months = ['April-2025', 'May-2025', 'June-2025', 'July-2025', 'August-2025', 'September-2025', 'October-2025'];

const BillTable = ({ charges }) => {
  const [selected, setSelected] = useState([]);
  const toggleAll = (e) => setSelected(e.target.checked ? charges.map(c => c.id) : []);
  const toggle = (id) => setSelected(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);

  return (
    <div className="table-wrapper">
      <table>
        <thead>
          <tr>
            <th><input type="checkbox" onChange={toggleAll} /></th>
            <th>Charge Type</th>
            <th>Interest</th>
            <th>GST</th>
            <th>Amount</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {charges.map(c => (
            <tr key={c.id}>
              <td><input type="checkbox" checked={selected.includes(c.id)} onChange={() => toggle(c.id)} /></td>
              <td>{c.type}</td>
              <td><Badge color="blue">Yes</Badge></td>
              <td><Badge color="red">No</Badge></td>
              <td><span className="td-amount credit">₹{c.amount?.toLocaleString('en-IN')}</span></td>
              <td><Button size="sm" variant="secondary">Edit</Button></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="table-footer">
        <span>{selected.length} of {charges.length} selected</span>
      </div>
    </div>
  );
};

export function RegularBillPage() {
  const [duration, setDuration] = useState('');
  const [billDate, setBillDate] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [status, setStatus] = useState('');
  const charges = ChargesController.getAll();

  return (
    <div className="fade-in">
      <PageHeader title="Regular Bill Charges" description="Generate regular bills for all members" />
      <Card style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-4" style={{ marginBottom: 14 }}>
          <FormGroup label="Bill Duration">
            <Select value={duration} onChange={e => setDuration(e.target.value)} options={months} placeholder="---Select---" />
          </FormGroup>
          <FormGroup label="Charges Settings">
            <Select options={['Select']} placeholder="Select" />
          </FormGroup>
          <FormGroup label="Bill Generation Date" required>
            <Input type="date" value={billDate} onChange={e => setBillDate(e.target.value)} />
          </FormGroup>
          <FormGroup label="Bill Due Date" required>
            <Input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} />
          </FormGroup>
        </div>
        <div className="form-grid form-grid-2" style={{ marginBottom: 14 }}>
          <FormGroup label="Status">
            <Select value={status} onChange={e => setStatus(e.target.value)} options={['Generated', 'Pending', 'Cancelled']} placeholder="Select" />
          </FormGroup>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button variant="amber" style={{ background: '#d97706', color: '#fff' }}>View Bill</Button>
          <Button variant="secondary">Send Mail</Button>
          <Button variant="secondary">Send WhatsApp</Button>
          <Button variant="secondary">Bill Register</Button>
          <Button variant="secondary">Receipts Register</Button>
          <Button variant="secondary">Meter Readings</Button>
          <Button variant="secondary">Change Status</Button>
        </div>
      </Card>
      <Card title="Regular Charges Applicable in Bill">
        <BillTable charges={charges} />
      </Card>
    </div>
  );
}

export function RegularBillIndividualPage() {
  const [selected, setSelected] = useState('Generated');
  const [duration, setDuration] = useState('August-2025');
  const [flatNo, setFlatNo] = useState('');

  return (
    <div className="fade-in">
      <PageHeader title="Regular Single Bill Updation" description="Update bill for a single flat/member" />
      <Card>
        <div className="form-grid form-grid-3">
          <FormGroup label="Select">
            <div className="radio-group">
              <label className="radio-label"><input type="radio" checked={selected === 'Generated'} onChange={() => setSelected('Generated')} /> Generated</label>
              <label className="radio-label"><input type="radio" checked={selected === 'Not Generated'} onChange={() => setSelected('Not Generated')} /> Not Generated</label>
            </div>
          </FormGroup>
          <FormGroup label="Bill Duration" required>
            <Select value={duration} onChange={e => setDuration(e.target.value)} options={months} placeholder="Select" />
          </FormGroup>
          <FormGroup label="Flat No" required>
            <Select value={flatNo} onChange={e => setFlatNo(e.target.value)} options={['F0101', 'F0102', 'F0103', 'F0201', 'F0202', 'F0203']} placeholder="Select" />
          </FormGroup>
        </div>
      </Card>
    </div>
  );
}

export function SupplementaryBillPage() {
  const [duration, setDuration] = useState('');
  const [billDate, setBillDate] = useState('');
  const [dueDate, setDueDate] = useState('');
  const suppCharges = [
    { id: 1, type: 'Terrace shade charges', gst: 'No', amount: 5000 },
    { id: 2, type: 'Society light Charge', gst: 'No', amount: 1000 },
    { id: 3, type: 'Assets', gst: 'Yes', amount: 900000 },
    { id: 4, type: 'Wall Painting Charges', gst: 'No', amount: 500 },
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Supplementary Bill Charges" description="Generate supplementary bills for special charges" />
      <Card style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Bill Duration" required>
            <Select value={duration} onChange={e => setDuration(e.target.value)} options={months} placeholder="---Select---" />
          </FormGroup>
          <FormGroup label="Bill Generation Date" required>
            <Input type="date" value={billDate} onChange={e => setBillDate(e.target.value)} />
          </FormGroup>
          <FormGroup label="Bill Due Date" required>
            <Input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} />
          </FormGroup>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button variant="secondary">Send Mail</Button>
          <Button variant="secondary">Send SMS</Button>
          <Button variant="secondary">Bill Register</Button>
          <Button variant="secondary">Receipts Register</Button>
        </div>
      </Card>
      <Card title="Supplementary Charges Applicable in Bill">
        <BillTable charges={suppCharges} />
      </Card>
    </div>
  );
}

export function SupplementaryBillIndividualPage() {
  const [selected, setSelected] = useState('Generated');

  return (
    <div className="fade-in">
      <PageHeader title="Supplementary Single Bill Updation" description="Update supplementary bill for a single flat/member" />
      <Card>
        <div className="form-grid form-grid-3">
          <FormGroup label="Select">
            <div className="radio-group">
              <label className="radio-label"><input type="radio" checked={selected === 'Generated'} onChange={() => setSelected('Generated')} /> Generated</label>
              <label className="radio-label"><input type="radio" checked={selected === 'Not Generated'} onChange={() => setSelected('Not Generated')} /> Not Generated</label>
            </div>
          </FormGroup>
          <FormGroup label="Bill Duration" required>
            <Select options={months} placeholder="Select" />
          </FormGroup>
          <FormGroup label="Flat No" required>
            <Select options={['F0101', 'F0102', 'F0103', 'F0201', 'F0202']} placeholder="Select" />
          </FormGroup>
        </div>
      </Card>
    </div>
  );
}
